import React, { useState } from 'react';
import './FAQSection.css';

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What types of plots does Faidika Real Estate offer in Malindi?",
      answer: "Faidika Real Estate offers a variety of plots in Malindi, including 1/8th acre, 1/4 acre, and full acre plots, suitable for residential or investment purposes."
    },
    {
      question: "Is the land offered by Faidika Real Estate titled?",
      answer: "Yes, all plots offered by Faidika Real Estate come with proper titles and documentation to ensure a secure and transparent transaction process."
    },
    {
      question: "How can I purchase a plot from Faidika Real Estate?",
      answer: "Purchasing a plot is simple. Contact our team, select your preferred plot size, and complete the necessary documentation. Our team will guide you through every step of the process."
    },
    {
      question: "Are there financing options available for buying land?",
      answer: "Yes, Faidika Real Estate provides flexible payment plans and financing options to make land ownership accessible and affordable for all our clients."
    },
    {
      question: "What amenities are available near the plots in Malindi?",
      answer: "The plots are strategically located near essential amenities such as schools, hospitals, shopping centers, and recreational facilities, ensuring a convenient lifestyle for residents."
    },
    {
      question: "Why should I invest in land with Faidika Real Estate?",
      answer: "Investing with Faidika Real Estate guarantees you prime land with clear titles, professional service, and a hassle-free buying experience. Our plots in Malindi are in high-demand areas, promising excellent returns on investment."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <h3>FAQ's</h3>
      <h1>Frequently Asked Questions</h1>
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div className="faq-item" key={index}>
            <div 
              className={`faq-question ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleAccordion(index)}
            >
              {faq.question}
              <span className="accordion-icon">{activeIndex === index ? '−' : '+'}</span>
            </div>
            <div className={`faq-answer ${activeIndex === index ? 'show' : ''}`}>
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;